import { useState, useEffect } from "react"
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import { NodeAPIService } from "../../../services/apis/NodeAPIService";
import { EntityAPIService } from "../../../services/apis/EntityAPIService";
import { TokenService } from "../../../services/TokenService";
import '../../../css/administration.css'
import BasicCard from "../../../components/basics/cards/BasicCard";
import AlertMessage from "../../../components/AlertMessage";
import { ErrorService } from "../../../services/ErrorService"

export default function ManageNode() {
    const [nodes, setNodes] = useState([]);
    const [nodeId, setNodeId] = useState(0);
    const [coupledEntities, setCoupledEntities] = useState([]);
    const [entities, setEntities] = useState([]);
    const [alertObject, setAlertObject] = useState({ variant: '', alertMessage: '' });
    const [error, setError] = useState('');

    useEffect(() => {
        const user = TokenService.getUser();        
        if (user != null && user.account.username != null) {
            NodeAPIService.getNodesByEmail().then(data => {
                if (!data.error) {
                    setNodes(data);
                    if (document.getElementById("nodeId") != undefined) {
                        document.getElementById("nodeId").value = 0;
                        setError(false)
                    }
                }
                else
                    setError(ErrorService.getErrorMessage(data.error.status))
            });
        }
        else
            setNodes([]);

        EntityAPIService.getEntities().then(data => setEntities(data));        
        setCoupledEntities([]);
    }, [])

    const getEntitiesByNodeId = (e) => {        
        setAlertObject({ variant: '', alertMessage: '' });
        setNodeId(e.target.value);        
        setCoupledEntities([]);

        if (e.target.value != "") {            
            NodeAPIService.getEntitiesByNodeId(e.target.value).then(data => {                
                if (data.error) {
                    setError(ErrorService.getErrorMessage(data.error.status))
                }
                setCoupledEntities(data);
            });
        }
    }  

    const isEntityExistInCoupled = (entityId) => {        
        if (coupledEntities.some(entity => entity.entityId == entityId))
            return true;
        else    
            return false;
    }

    const handleCancel = () => {
        if (document.getElementById("nodeId") != undefined)
            document.getElementById("nodeId").value = 0;

        setCoupledEntities([]);
        setAlertObject({ variant: '', alertMessage: '' });
    }

    const moveEntities = (action) => {
        setAlertObject({ variant: '', alertMessage: '' });
        if (document.getElementById("tagetikEntities") != undefined) {

            if (action == "right") {
                var currCoupledEntities = [];
                for (var option of document.getElementById('coupledEntities').options) {
                    if (!option.selected) {                        
                        var entity = { entityCode: "", entityId: option.value, entityName: option.text };
                        currCoupledEntities.push(entity);                        
                    }
                }
                setCoupledEntities(currCoupledEntities);
                setEntities(entities);
            }

            if (action == "moveAllRight")
                setCoupledEntities([]);


            if (action == "left" || action == "moveAllLeft") {
                var currCoupledEntities = [];
                coupledEntities.map((coupledEntity) => {
                    var entity = { entityCode: coupledEntity.entityCode, entityId: coupledEntity.entityId, entityName: coupledEntity.entityName };
                    currCoupledEntities.push(entity);
                });

                setCoupledEntities([]);

                for (var option of document.getElementById('tagetikEntities').options) {
                    if (option.selected || action == "moveAllLeft" ) {
                        if (!currCoupledEntities.some(entity => entity.entityId === option.value)) {
                            var entity = { entityCode: "", entityId: option.value, entityName: option.text };
                            currCoupledEntities.push(entity);
                        }
                    }
                }
                setCoupledEntities(currCoupledEntities);
                setEntities(entities);
            }            
        }
    }

    const handleSave = (e) => {
        e.preventDefault();
        setAlertObject({ variant: '', alertMessage: '' });
        if (document.getElementById("nodeId") === undefined || document.getElementById("nodeId") == null || document.getElementById("nodeId").value === "0") {            
            setAlertObject({ variant: 'danger', alertMessage: 'Please choose a node from the node list to couple the tagetik entities!.' })
            return false;
        }

        //if (coupledEntities.length === undefined || coupledEntities.length == 0) {
        //    setAlertObject({ variant: 'danger', alertMessage: 'No entities to save, please add some entities!')
        //    return false;
        //}

        var nodeEntities = {
            Id: nodeId,
            Ids: coupledEntities.map(e => e.entityId)
        };        
        
        NodeAPIService.updateNodeEntities(nodeEntities).then(
            response => {
                if (response.error) {
                    setError(ErrorService.getErrorMessage(response.error.status))

                }
                setAlertObject({ variant: 'success', alertMessage: "Entities have been successfully added to the node." });
            }
        );
    }

    const AddRemoveClass = {        
        border: "1px solid #7f9db9",
    };

    return (        
        <div style={{ width: '100%' }}>
            <BasicCard cardConfig={{ cardTitle: 'Couple tagetik entity node' }}>
            {error ? <p style={{ color: 'red' }}>{error}</p> : ""}
            {alertObject.alertMessage ? <AlertMessage alertObject={alertObject} setAlertObject={setAlertObject} /> : ""}
                <Container>
                    <Row>
                        <Col>
                            <label>Couple Tagetik entity with node</label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>                            
                            <label>Entity and group:&nbsp;</label>
                            <select id='nodeId' name="nodeId" onChange={getEntitiesByNodeId} >
                                <option value="0">--Select--</option>
                                {nodes?.length > 0 ?
                                    nodes.map((node) => <option value={node.nodeId} key={node.nodeId}>{node.nodeName}</option>)
                                    : null
                                }
                            </select>                            
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Row>
                                <Col>
                                    <label>Coupled nodes</label>
                                </Col>
                            </Row>
                            <select
                                id='coupledEntities'
                                name='coupledEntities'
                                multiple
                                size='10'
                                label='Coupled nodes'
                                select-all="true"
                                select-all-text='Select all'
                                multiple-options-selected-text='{a} items selected'
                                className='select-tagetik-entity'
                                placeholder='--Select node(s)--'>
                                {coupledEntities?.length > 0 ?                                    
                                coupledEntities.map((coupledEntity) => <option value={coupledEntity.entityId} key={coupledEntity.entityId}>{coupledEntity.entityName}</option>) 
                                : null
                            }
                            </select> 
                        </Col>
                        <Col>
                            <span className='move-entities'>
                                <Button style={AddRemoveClass} onClick={() => moveEntities("left")}>&#60;</Button>&nbsp;
                                <Button style={AddRemoveClass} onClick={() => moveEntities("right")}>&#62;</Button>&nbsp;
                                <Button style={AddRemoveClass} onClick={() => moveEntities("moveAllLeft")}>&#60;&#60;</Button>&nbsp;
                                <Button style={AddRemoveClass} onClick={() => moveEntities("moveAllRight")}>&#62;&#62;</Button>&nbsp;
                            </span>
                        </Col>
                        <Col>
                            <Row>
                                <Col>
                                    <label>Tagetik reporting entitites</label>
                                </Col>
                            </Row>
                            <select
                                id='tagetikEntities'
                                multiple
                                size='10'
                                label='Tagetik reporting entitites'
                                select-all="true"
                                select-all-text='Select all'
                                multiple-options-selected-text='{a} items selected'                            
                                className='select-tagetik-entity'
                                placeholder='--Select entity/entities--'>
                                {entities?.length > 0 ?                            
                                    entities.filter(filterEntity => !isEntityExistInCoupled(filterEntity.entityId)).map((entitity) =>
                                        <option value={entitity.entityId} key={entitity.entityId}>{entitity.entityName}</option>)
                                    :<option value="0">&nbsp;</option>
                                }
                            </select>
                        </Col>
                    </Row>
                </Container>
                <span className='cancel-save' style={{marginTop: '1rem'}}>
                    <a href='#' onClick={handleCancel}>Cancel</a>
                    <Button variant='primary' className='node-admin-save' onClick={handleSave} style={{ marginLeft: '1rem' }}>Save</Button>
                </span>
            </BasicCard>
        </div>
    )
}
